import api from './index';

export const withdrawalsAPI = {
  getAll: (params) => api.get('/withdrawals', { params }),
  create: (data) => api.post('/withdrawals', data),
};
